/**
 * @generated SignedSource<<7de24e157499281fd504907f2bb17d89>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sectionStyleMainArticleListSection$data = {
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"sectionStyleSectionSection">;
  readonly " $fragmentType": "sectionStyleMainArticleListSection";
};
export type sectionStyleMainArticleListSection$key = {
  readonly " $data"?: sectionStyleMainArticleListSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"sectionStyleMainArticleListSection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "sectionStyleMainArticleListSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "sectionStyleSectionSection"
    }
  ],
  "type": "Section",
  "abstractKey": null
};

(node as any).hash = "9c2d53f8a223a160cf61047018aec47b";

export default node;
